import classNames from 'classnames';
import React from 'react';
import { useDrop } from 'react-dnd';
import * as styles from './ContentMapDroppableSeparator.module.scss';
import type { ContentMapDropParams } from './utils/types';

interface ContentMapDroppableSeparatorProps extends ContentMapDropParams {
  hide?: boolean;
}

const ContentMapDroppableSeparator = ({
  hide,
  ...dropTopicsParams
}: ContentMapDroppableSeparatorProps) => {
  const [{ isOver, isDragging }, dropRef] = useDrop(dropTopicsParams);

  return (
    <div className={styles.container}>
      {!hide && <div className={styles.separator} />}
      {isOver && <div className={styles.overIndicator} />}
      <div
        ref={dropRef}
        className={classNames(styles.drop, {
          [styles.isDragging]: isDragging,
        })}
      />
    </div>
  );
};

export default ContentMapDroppableSeparator;
